const state = {
  isSubmitting: false,
  data: null
}

export const mutationTypes = {
  setLogin: '[login] login set'
}

const mutations = {
  [mutationTypes.setLogin](state, login) {
    state.data = login
  }
}

const actions = {}

export default {
  state,
  mutations,
  actions
}
